import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'

import './assets/styles/global.scss'
import './assets/styles/defined.scss'
import messages from './lang'

Vue.use(VueI18n)
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'zh-CN', // 设置地区
  messages // 设置地区信息
})

// Vue.prototype.$i18n = i18n

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
